
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ekosxefksjcibxsvwxkx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVrb3N4ZWZrc2pjaWJ4c3Z3eGt4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0OTEyMzAsImV4cCI6MjA2MTA2NzIzMH0.8HDHy-W69bsrNj9JuKgmQ89X4ToHp003eMxccQ0JWxk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: localStorage, // Explicitly use localStorage
    flowType: 'pkce' // Use latest auth flow
  },
  global: {
    headers: {
      'x-client-info': 'lovable-admin'
    }
  },
  db: {
    schema: 'public'
  },
  // Increase timeout for operations
  realtime: {
    timeout: 60000
  }
});

// Add convenience types for our custom RPC functions
declare module '@supabase/supabase-js' {
  interface SupabaseClient {
    rpc<T = any>(
      fn: 'is_admin' | 'has_role' | 'update_admin_status' | 'is_admin_check' | 'is_admin_safe_check' | 'get_all_profiles_emergency' | 'begin_transaction' | 'commit_transaction' | 'rollback_transaction',
      params?: { user_id?: string; } | { _user_id?: string; _role?: 'admin' | 'group_admin' | 'user'; } | { target_user_id?: string; is_admin_value?: boolean; }
    ): Promise<{ data: T; error: Error | null }>;
  }
}
